import { addMinutes } from 'date-fns';
import { SP_IN_MS } from 'src/types/date';

export const getAvailabilityCutOffForStartOrEnd = (startOrEnd: Date) =>
  addMinutes(startOrEnd, -11);

const getNextSp = (date: Date) =>
  new Date(Math.floor(+date / SP_IN_MS) * SP_IN_MS + SP_IN_MS);

export const getNextValidAvailabilitySp = (date: Date) => {
  const nextSp = getNextSp(date);

  if (date >= getAvailabilityCutOffForStartOrEnd(nextSp)) {
    return addMinutes(nextSp, 30);
  }

  return nextSp;
};
